<template>
    <div class="user-center-page">
        <div class="header-top">
            <div class="h-avatar">
                <div class="avatar-img" title="点击更新头像">
                    <div class="img-box">
                        <img v-if="userInfo.headImage" class="img" :src="userInfo.headImage">
                    </div>
                    <div class="tag-box">
                        <span class="tag" v-if="userType == 1">品牌商</span>
                        <span class="tag" v-if="userType == 2">生产商</span>
                        <span class="tag" v-if="userType == 9">直播相关</span>
                    </div>
                    <el-upload
                        name='files'
                        :data="{
                            imageType:'20101',
							imageUserId: userId,
                        }"
                        :action="uploadApi"
                        :show-file-list="false"
                        :on-success="onUploadSuccess"
                        :on-error="onUploadError"
                        class="avatar-upload"
                    >
                        <div class="upload-default">
                            <!-- <el-button class="ic-plus" size="mini" icon="el-icon-plus" circle></el-button> -->
                        </div>
                    </el-upload>
                </div>
                <div class="name">{{userInfo.companyName || phone}}</div>
            </div>
            
            <span class="status" v-if="userIsAuth == 'y'">已认证</span>
            <span class="status" v-if="userIsAuth == 'p'">认证审核中</span>
            <span class="status" v-if="userIsAuth == 'n'">认证被拒绝</span>
            <span class="status" v-if="userIsAuth == 'never'">未认证</span>
        </div>

        <div class="to-auth-wrap" v-if="userIsAuth == 'never'">
            <el-link type="primary" @click="toAuthPage">前往认证企业信息 &gt;&gt;</el-link>
        </div>
        <div class="to-auth-wrap" v-if="userIsAuth == 'n'">
            <el-link type="primary" @click="toAuthPage">重新认证企业信息 &gt;&gt;</el-link>
        </div>
        
        <template v-if="userType == 1">
            <brand-user />
        </template>
        <template v-if="userType == 2">
            <factory-user />
        </template>

        <template v-if="userType == 9">
            <live-user />
        </template>
   
    </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import brandUser from './components/brandUser'
import factoryUser from './components/factoryUser'
import liveUser from './components/liveUser'

export default {
    components: {
        brandUser,
        factoryUser,
        liveUser
    },
    data() {
        return {
            uploadApi: api.uploadfilebatch,
        }
    },
    computed: {
        ...mapGetters(['userId', 'userType', 'userIsAuth', 'phone', 'userInfo'])
    },
    created() {

    },
    mounted() {
        this.setBodyBgColor('mounted')
    },
    beforeDestroy() {
        this.setBodyBgColor('beforeDestroy')
    },
    methods: {
        // 设置body背景色
        setBodyBgColor(sign) {
            if (sign === 'mounted') {
                document.querySelector('body').setAttribute('style', 'background-color: #fff')
                return;
            }
            if (sign === 'beforeDestroy') {
                document.querySelector('body').removeAttribute('style')
                return;
            }
        },
        // 上传头像
        onUploadSuccess(res, file, fileList) {
            if (res.errorCode == 200) {
                this.$store.dispatch('getUserInfo')
            } else {
                this.$message.error('上传失败')
            }
        },
        onUploadError(err, file, fileList) {
            // console.log('onUploadError', err, file, fileList)
            this.$message.error('上传失败')
        },
        toAuthPage() {
            this.$router.push('/auth')
        }
    }
}
</script>

<style lang="scss">
.user-center-page {
    margin: 0 auto;
    width: 1184px;
    padding: 24px 0;
    .header-top {
        height: 108px;
        box-sizing: border-box;
        padding: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: url(../../assets/images/user_top_bg.jpg) no-repeat;
        background-size: cover;
        .h-avatar {
            display: flex;      
            align-items: center;
            .avatar-img {
                width: 60px;
                height: 60px;
                position: relative;
                &:hover {
                    .avatar-upload {
                        display: block;
                    }
                }
            }
            .img-box {
                width: 60px;
                height: 60px;
                background: url(../../assets/images/avatar_default.png) no-repeat center/100% 100%;
                border-radius: 50%;
                overflow: hidden;
                .img {
                    width: 60px;
                    height: 60px;
                    box-sizing: border-box;
                    border-radius: 50%;
                    object-fit: cover;
                    background: #ccc;
                }
            }
            .tag-box {
                position: absolute;
                bottom: -4px;
                left: -10px;
                width: 80px;
                height: 20px;
                text-align: center;
                font-size: 0;
            }
            .tag {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.85);
                line-height: 20px;
                padding: 0 8px;
                background: #DBAB80;
                border-radius: 2px;
            }
            .avatar-upload {
                position: absolute;
                top: 0;
                left: 0;
                width: 60px;
                height: 60px;
                display: none;
                .upload-default {
                    width: 60px;
                    height: 60px;
                    .ic-plus {
                        position: absolute;
                        left: 44px;
                        top: -8px;
                    }
                }
            }
            .name {
                margin-left: 16px;
                height: 32px;
                font-size: 24px;
                font-weight: 500;
                color: #6E5535;
                line-height: 32px;

            }
        }
        .status {
            height: 36px;
            background: #FFFFFF;
            border-radius: 2px;
            padding: 0 28px;
            font-size: 14px;
            font-weight: 500;
            color: #6E5535;
            line-height: 36px;
        }

    }
    .to-auth-wrap {
        padding: 42px 0;
        text-align: center;
        border-bottom: 1px solid #f0f0f0;
    }
    .main-wrap {
        .item {
            padding: 24px 0 24px 48px;
            border-bottom: 1px solid #f0f0f0;
            display: flex;
            .label {
                width: 300px;
                padding: 20px 0;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
                line-height: 22px;
            }
            .content {
                width: 700px;
                .text {
                    width: 90%;
                    padding: 20px 0;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 22px;
                }
                .cate-text {
                    padding: 20px 0;
                }
                .cate-line {
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 22px;
                    display: flex;
                    margin-bottom: 24px;
                    &:last-child {margin-bottom: 0}
                }
                .cate-lab {width: 50px;}
                .cate-con {
                    width: 500px;
                    span {
                        display: inline-block;
                        color: rgba(0, 0, 0, 0.65); 
                        margin-right: 16px;
                    }
                    
                }
                .edit-box {
                    width: 70%;
                    padding-top: 8px;
                }
            }
            .btn-wrap {
                width: 160px;
                height: 56px;
                display: flex;
                align-items: center;
                .icon-edit {
                    width: 48px;
                    height: 48px;
                    background: url(../../assets/icons/icon_edit.png) no-repeat center/24px 24px;
                    cursor: pointer;
                    &:hover {opacity: 0.8;}
                }
            }
        }
    }
    .cate-pop {
        .cate-line {
            margin-bottom: 16px;
            display: flex;
        }
        .cate-lab {
            font-weight: normal;
            width: 54px;
        }
        .cate-select {
            width: 600px;
            .el-tag {margin-right: 16px;}
            &.w {width: 800px;}
            .el-checkbox {width: 16%;}
        }
    }
    .el-tag {
        margin-right: 10px;
    }
    .button-new-tag {
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 150px;
        vertical-align: bottom;
    }
    
}
</style>